import { Loader } from '@nosinovacao/fe-icons';
import { Button, Otp, useI18n, widgets } from '@nosinovacao/nosid-mfe-common';
import { useEffect, useRef, useState } from 'react';
import { type ValidateProps } from '../-model/props';

const KEY_PREFIX = 'Security.AuthenticatorAppCard.Setup.Validate';

export function ValidateLight({
  codeErrors,
  codeId,
  codeValue,
  disabled,
  hasRequiredError,
  loading,
  onCodeChange,
  onSubmit,
}: Readonly<ValidateProps>) {
  const { t } = useI18n();
  const [autoSubmit, setAutoSubmit] = useState(true);
  const formRef = useRef<HTMLFormElement>(null);
  const codeLength = codeValue.length;

  useEffect(() => {
    if (disabled || !autoSubmit || codeLength !== widgets.ValidationCodeLength) return;
    setAutoSubmit(false);
    formRef.current?.requestSubmit();
    // ? dismisses the mobile keyboard so the user can see the result
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeLength]);

  return (
    <form ref={formRef} onSubmit={onSubmit} className="contents" data-tid="form-code-input">
      <div className="grid flex-1 auto-rows-max content-start justify-items-center gap-6 overflow-y-auto pt-1">
        <Otp
          data-tid="otp-code"
          skin="light"
          id={codeId}
          value={codeValue}
          errors={codeErrors}
          length={widgets.ValidationCodeLength}
          disabled={disabled}
          onChange={onCodeChange}
          autoFocus
        />
      </div>
      <footer className="grid pt-2">
        <Button
          skin="light"
          type="submit"
          disabled={disabled || hasRequiredError}
          data-tid="validate-button"
          className="w-full px-4 tablet:w-fit tablet:justify-self-start"
        >
          {loading ? <Loader height={24} width={24} /> : t(`${KEY_PREFIX}.Button`)}
        </Button>
      </footer>
    </form>
  );
}
